import { Sizes } from '@theme/globals/sizing';

const formField = {
  border: {
    color: 'gray-300',
    side: 'all',
  },
  error: {
    color: 'status-error',
    margin: {
      left: '0px',
      top: 'xsmall',
      right: '0px',
      bottom: '0px',
    },
    size: 'body',
  },
  label: {
    color: 'gray-300',
    margin: {
      bottom: 'xxsmall',
      top: 'none',
      horizontal: 'hair',
    },
    size: 'body',
  },
  margin: 'none',
  round: Sizes[12],
};

export default formField;
